/* eslint-disable */
//@ts-ignore

// 这个文件只是为了兼容而已
// 请改为通过 lib/exts 导入！！！！！！！

import LessCode from '../lib/exts/LessCode';
export default LessCode;
